module.exports = __webpack_public_path__ + "img/cashier_btn_kaika@2x.3d27a346.png";